// export const BaseUrl = "http://172.20.10.3:3000";
export const BaseUrl = "https://webview.hijradigital.com";
// export const BaseUrl = "https://donateuat.hijradigital.com";
// export const BaseUrl = "http://localhost:3000";

